import { combineEpics, Epic } from 'redux-observable'
import {
  catchError,
  filter,
  map,
  mergeMap,
  withLatestFrom,
} from 'rxjs/operators'
import { merge, of } from 'rxjs'
import { AnyAction } from 'redux'
import * as R from 'ramda'
import { AjaxResponse } from 'rxjs/ajax'
import { restriksjonerActionsTypes, restriksjonerActions } from '../store'
import { ICommonApi } from '../../../../../api'
import { IStoreState } from '../../../../../reducers/types'
import { ENDPOINT } from '../../../../../constants'
import { commonRedux } from '../../../../../common/redux'
import { toast } from '../../../../toast'

const { isOfType } = commonRedux

export const fetchRestriksjonerListByIdEpic =
  (commonApi: ICommonApi): Epic<AnyAction, AnyAction, IStoreState> =>
  (action$, state$) =>
    action$.pipe(
      filter(isOfType(restriksjonerActionsTypes.FETCH_LIST_BY_IDS)),
      withLatestFrom(state$),
      filter(([{ ids }]) => R.not(R.isEmpty(ids))),
      mergeMap(([{ ids }, state]) => {
        return of(state).pipe(
          commonApi.post(
            `${ENDPOINT.TILSYNSOBJEKT}/v1/tilsynsobjekter/restriksjoner`,
            state,
            ids
          ),
          map(
            (resp: AjaxResponse<any>) =>
              resp.response._embedded.tilsynsobjektIdRestriksjonerList
          ),
          map((data) =>
            data.map((tilsynsobjektRestriksjoner) => ({
              ...tilsynsobjektRestriksjoner,
              restriksjoner: tilsynsobjektRestriksjoner?.restriksjoner?.filter(
                (restriksjon) =>
                  restriksjon?.aarsak?.id !==
                  'BEGRENSNINGSAARSAK$BRUDD_PAA_DYREVELFERDREGELVERKET'
              ),
            }))
          ),
          map((data) => restriksjonerActions.fetchListByIdsOk(data)),
          catchError((err) =>
            merge(
              of(
                toast.actions.showToast({
                  text: 'Kunne ikke hente restriksjoner.',
                  timeoutSeconds: 5,
                  dismissible: true,
                  type: 'DANGER',
                })
              ),
              of(restriksjonerActions.fetchListByIdsFail(ids, err.message))
            )
          )
        )
      })
    )

const restriksjonerEpic = (commonApi: ICommonApi) =>
  combineEpics(fetchRestriksjonerListByIdEpic(commonApi))

export default restriksjonerEpic
